module.exports = __webpack_public_path__ + "img/3.a2ef3041.png";